import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/.pnpm/next-intl@3.26.5_next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1._fa4vikktssq6zfag5mtrvu3rfu/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-plugin_5r4bdk4zioirrgoy4qpyhz5n3y/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-plugin_5r4bdk4zioirrgoy4qpyhz5n3y/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-plugin_5r4bdk4zioirrgoy4qpyhz5n3y/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationSEO"] */ "/usr/src/app/src/app/(routes)/OrganizationSchemaSeo.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/(routes)/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/(routes)/styles/block-global-styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/(routes)/styles/locale-styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/cards/home/MediaCard.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/cards/home/VideoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselContent","CarouselItem","CarouselPrevious","CarouselNext"] */ "/usr/src/app/src/app/components/carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/common/AutoPlayByScroll.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/common/mini-player/MiniVideoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/common/VideoModal/VideoModal.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/link/LinkWithChannel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TVShowPlayLink"] */ "/usr/src/app/src/app/components/link/TVShowLink.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/media/LiveTvVideoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/media/VideoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/notification/BreakingNewsContent.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/notification/BreakingNewsDots.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/notification/BreakingNewsWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/pages/home/LiveTvWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleUppercase"] */ "/usr/src/app/src/app/components/text/LocaleUppercase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingTime"] */ "/usr/src/app/src/app/components/text/ReadingTime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/usr/src/app/src/providers/RootProviders.tsx");
